import React from "react";
import "./HeroSection.css";
import "../App.css";
import { Button } from "./Button";
import { Link } from "react-router-dom";

function HeroSection() {
  const words = ["coder", "designer"];

  return (
    <div className="hero-container">
      <div className="intro">
        <div id="helloName">
          <span id="hello">Hello, I'm </span>
          <span id="name">Kelly Chen. </span>
        </div>
        <p>
          <span class="type">
            <a
              class="typewrite"
              data-period="2000"
              data-type='["I Love to Develop.", "I Am Passionate About Design.", "I Love to Play Games."]'
            >
              <span class="wrap"></span>
            </a>
          </span>{" "}
        </p>
      </div>

      <p id="description">
        A curious and self driven 3rd-year college student majoring in Game
        Design and Development and minoring in web development and Japanese.
      </p>
      <div className="buttons">
        <Button
          className="btns"
          buttonStyle="btn--primary"
          buttonSize="btn--large"
          path="/projects"
        >
          Code
        </Button>
        <Button
          className="btns"
          buttonStyle="btn--primary"
          buttonSize="btn--large"
          path="/designs"
        >
          Designs
        </Button>
      </div>
    </div>
  );
}
var TxtType = function (el, toRotate, period) {
  this.toRotate = toRotate;
  this.el = el;
  this.loopNum = 0;
  this.period = parseInt(period, 10) || 2000;
  this.txt = "";
  this.tick();
  this.isDeleting = false;
};

TxtType.prototype.tick = function () {
  var i = this.loopNum % this.toRotate.length;
  var fullTxt = this.toRotate[i];

  if (this.isDeleting) {
    this.txt = fullTxt.substring(0, this.txt.length - 1);
  } else {
    this.txt = fullTxt.substring(0, this.txt.length + 1);
  }

  this.el.innerHTML = '<span class="wrap">' + this.txt + "</span>";

  var that = this;
  var delta = 200 - Math.random() * 100;

  if (this.isDeleting) {
    delta /= 2;
  }

  if (!this.isDeleting && this.txt === fullTxt) {
    delta = this.period;
    this.isDeleting = true;
  } else if (this.isDeleting && this.txt === "") {
    this.isDeleting = false;
    this.loopNum++;
    delta = 500;
  }

  setTimeout(function () {
    that.tick();
  }, delta);
};

window.onload = function () {
  var elements = document.getElementsByClassName("typewrite");
  for (var i = 0; i < elements.length; i++) {
    var toRotate = elements[i].getAttribute("data-type");
    var period = elements[i].getAttribute("data-period");
    if (toRotate) {
      new TxtType(elements[i], JSON.parse(toRotate), period);
    }
  }
  // INJECT CSS
  var css = document.createElement("style");
  css.type = "text/css";
  css.innerHTML = ".typewrite > .wrap { border-right: 0.08em solid #ffffff}";
  document.body.appendChild(css);
};

export default HeroSection;
